import { ref } from 'vue';

const messages = ref({});
const locale = ref('ru');

export function useI18n() {
	async function initI18n(code) {
		locale.value = code;

		messages.value = await import(`./locales/${code}.js`)
			.then(m => m.default)
			.catch((err) => {
				console.error('i18n load error', err);
				return {};
			});
	}

	function t(key, params) {
		if (!Object.keys(messages.value).length)
			return '';

		const value = key.split('.').reduce(
			(acc, part) => acc?.[part],
			messages.value,
		);

		if (typeof value === 'function') {
			return value(params);
		}

		return value;
	}

	return { t, initI18n, locale };
}